// Fallback for pages without their own page module — most of the site. Every
// page still gets the singletons (header, confirm dialogs); this is just the
// "nothing else to do here" case.
import { registerPage } from "../first"

export const Page = {}

registerPage("Page", Page)
